import login from "./login";
import community from "./community";
import goodsPromotionService from "./goodsPromotionService";
import merchantService from "./merchantService";
import doctorCommunity from "./doctorCommunity";
import * as doctorInvite from "./doctorInvite";
import * as doctorList from "./doctorList";
import * as newComtyDataManage from "./newComtyDataManage";
import * as userManage from "./userManage";
import * as newComtyDrudManage from "./newComtyDrugManage";
import * as prescriptionTemplateManage from "./prescriptionTemplateManage";
import * as serviceManage from "./serviceManage";
import * as contentSync from "./contentSynchronization";
import * as contentManage from "./contentManage";
import * as activityManage from "./activityManage";
import * as finance from "./finance";
import * as geneManage from "./geneManage";
import * as commonLabel from "./commonLabel";
import * as authority from "./authority";
import * as accountBind from "./accountBind";
import * as outpatientServiceNew from "./outpatientServiceNew";
import * as newCoupon from "./newCoupon";
import * as customerService from "./customerService";
import * as coupon from "./coupon";
import * as activeCenter from "./activeCenter";
import * as caseActivity from "./caseActivity";
import * as caseManager from "./caseManager";
import * as distribute from "./distribute";
import * as basicSetting from "./basicSetting";
import * as defaultActivity from "./defaultActivity";
import * as featuredProjects from "./featuredProjects";
import customerServiceMessage from "./customerServiceMessage";
import accountBindNew from "./accountBindNew";
import appointmentArrival from "./appointmentArrival";
import store from "./store";
import * as recommend from "./recommend";
import * as userOperation from "./userOperation";
import * as useGroup from "./useGroup";
import * as privateOperation from "./privateOperation";
import * as dataCenter from "./dataCenter";
import * as operationSchool from "./operationSchool";
import * as newOperationTools from "./newOperationTools";
export default {
  ...login,
  ...community,
  goodsPromotionService,
  merchantService,
  ...doctorCommunity,
  ...newComtyDataManage,
  ...doctorInvite,
  ...newComtyDrudManage,
  ...doctorList,
  ...userManage,
  ...prescriptionTemplateManage,
  ...serviceManage,
  ...contentSync,
  ...contentManage,
  ...activityManage,
  ...finance,
  ...geneManage,
  ...authority,
  ...commonLabel,
  ...accountBind,
  ...outpatientServiceNew,
  ...newCoupon,
  ...customerService,
  ...customerServiceMessage,
  ...coupon,
  ...activeCenter,
  ...caseActivity,
  ...caseManager,
  ...distribute,
  ...basicSetting,
  ...defaultActivity,
  ...featuredProjects,
  ...appointmentArrival,
  ...accountBindNew,
  ...store,
  ...recommend,
  ...userOperation,
  ...useGroup,
  ...privateOperation,
  ...dataCenter,
  ...operationSchool,
  ...newOperationTools
};